/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosChainInfo } from '../models/AptosChainInfo';
import type { AptosGeneralInfo } from '../models/AptosGeneralInfo';
import type { AptosGeneralSummaryInfo } from '../models/AptosGeneralSummaryInfo';
import type { SseEmitter } from '../models/SseEmitter';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosGeneralControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns AptosGeneralInfo OK
     * @throws ApiError
     */
    public getAptosGeneral({
        types,
    }: {
        types: string,
    }): CancelablePromise<AptosGeneralInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/general',
            query: {
                'types': types,
            },
        });
    }

    /**
     * @returns AptosGeneralSummaryInfo OK
     * @throws ApiError
     */
    public getAptosGeneralSummary(): CancelablePromise<AptosGeneralSummaryInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/general/summary',
        });
    }

    /**
     * @returns SseEmitter OK
     * @throws ApiError
     */
    public streamAptosGeneralSummary(): CancelablePromise<SseEmitter> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/general/summary/sse',
        });
    }

    /**
     * @returns SseEmitter OK
     * @throws ApiError
     */
    public streamAptosGeneral({
        types,
    }: {
        types: string,
    }): CancelablePromise<SseEmitter> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/general/sse',
            query: {
                'types': types,
            },
        });
    }

    /**
     * @returns AptosChainInfo OK
     * @throws ApiError
     */
    public getChainInfo1(): CancelablePromise<AptosChainInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/general/chain',
        });
    }

}
